import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { key_local_storage_user } from '../../lib/backend/data';

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        localStorage.getItem(key_local_storage_user)
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />
)